module.exports = __webpack_public_path__ + "img/capsules.90d380ad.svg";